import { cx } from '@vizit/theme';
import * as React from 'react';
interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  children: React.ReactNode;
}

const Form = React.forwardRef<HTMLFormElement, FormProps>((props, ref) => {
  const { children, className, ...rest } = props;

  return (
    <form className={cx('grid gap-2 px-16', className)} {...rest} ref={ref}>
      {children}
    </form>
  );
});

export { Form };
export type { FormProps };
